module.exports = __webpack_public_path__ + "img/12.0b20db22.svg";